import { render, staticRenderFns } from "./duoTileView.vue?vue&type=template&id=4b5c8bf3&scoped=true&"
import script from "./duoTileView.vue?vue&type=script&lang=js&"
export * from "./duoTileView.vue?vue&type=script&lang=js&"
import style0 from "./duoTileView.vue?vue&type=style&index=0&id=4b5c8bf3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c8bf3",
  null
  
)

export default component.exports